//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
export default {
  props: [
    'name'
  ],
  computed: {
    offers() {
      if (this.$route.name === 'account-offers') {
        return true
      } else {
        return false
      }
    }
  }
}
